<script>
    import Conexoes from "../Classes/Conexoes.js";
    import Constantes from "../Classes/Constantes.js";

    import CaixaDeDialogo from "./CaixaDeDialogo.svelte";
    import Loading from "./Loading.svelte";

    export let api;

    let conexao = new Conexoes();
    let resultado;
    export let entrada = "";
    let saida = "";
    export let parametros;
    export let id;
    export let rotulo;
    export let tamanho;
    export let classe;
    export let obrigatorio = false;
    let carregando = false;

    let inputValue = "";
    let botaoTexto = "Validar"; // Estado do botão: "validar" ou "validado"
    let classeBtn = "validar";

    async function PegaDados() {
        carregando = true;

      
        if (obrigatorio) {
            parametros["validacao"] = saida;
        } else {
            parametros["validacao"] = entrada;
        }

        resultado = await conexao.conecta(api, parametros);
        carregando = false;

        if (resultado[0] && resultado[0].id) {
            botaoTexto = "Validado";
            classeBtn = "valida";
            if (obrigatorio) {
                entrada = saida;
            }
        } else {
            if (obrigatorio) {
                entrada = "";
                saida = "";
            }
            botaoTexto = "Inválido";
            classeBtn = "invalida";
        }
    }

    function AtualizarNome() {
        botaoTexto = "Validar";
        classeBtn = "validar";
      
    }
</script>

<div class="d-flex align-items-center w-100 largura">
    {#if obrigatorio}
        <input
            type="text"
            bind:value={saida}
            maxlength={tamanho}
            placeholder={rotulo}
            {id}
            class={classe}
            on:input={AtualizarNome}
        />
    {:else}
        <input
            type="text"
            bind:value={entrada}
            maxlength={tamanho}
            placeholder={rotulo}
            {id}
            class={classe}
            on:input={AtualizarNome}
        />
    {/if}
    {#if carregando}
        <i class="fas fa-spinner fa-spin loading"></i>
    {/if}
    <button class={classeBtn} on:click={PegaDados} disabled={carregando}>
        {botaoTexto}
    </button>
</div>

<style>
    .largura {
        width: 100%;
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 5px;
        display: flex;
        align-items: center;
    }
    input {
        margin-left: 2px;
        flex-grow: 1;
    }
    .search-icon {
        padding-inline: 5px;
        right: 0.5rem;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
    }
    .loading {
        height: 50px; /* Altura do ícone de carregamento */
    }
    .fa-spinner {
        animation: spin 1s infinite linear; /* Animação de rotação */
        display: flex;
        justify-content: center;
        align-items: center;
        padding-inline: 5px;
    }
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    button {
        margin-left: 10px;
        padding: 5px 10px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        color: white;
        white-space: nowrap; /* Evita quebra de linha no texto do botão */
        min-width: 100px; /* Define uma largura mínima para o botão */
    }
    .valida {
        background-color: #28a745; /* Verde para validado */
    }
    .invalida {
        background-color: brown; /* Marrom para inválido */
    }
    .validar {
        background-color: #007bff; /* Azul para validar */
    }
</style>
